/**
 * The one Support page (`/dashboard/support`): administrators with project
 * governance on get the project workbook there, everyone else the ticket list
 * (see SupportHub / SupportItemPage). `?view=tickets` forces the plain ticket
 * screens for anyone, so links inside that view carry the flag along.
 */

export const SUPPORT_BASE = "/dashboard/support";

/** `?view=tickets` — the plain Support ticket screens, even for admins. */
export const isTicketView = (params: URLSearchParams): boolean => params.get("view") === "tickets";

/** Adds `view=tickets` to an in-app URL. */
export const withTicketView = (url: string): string => `${url}${url.includes("?") ? "&" : "?"}view=tickets`;

export const TICKET_VIEW_URL = withTicketView(SUPPORT_BASE);
